define(function(require) {
	const IpsModel = require('civicsBase/ipsModel');
	return IpsModel.extend({
		urlRoot:'/delegate/civics-api/api/cdr/applications/{0}'
	});
});
